import React, { useEffect, useState, useRef, Component, useMemo } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { withFormik, Form } from "formik";
import PromiseWrapper from "../Utils/PromiseDialog";
import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import { FormRow, SelectRow, callSend } from "../Form/Form";
import {
    validateEmail50, validateString50,
    validateSomething,
    validateString75,
    validateOptional50
} from "../../components/Form/Validations";

import RestAPI from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import LoadingDialog from "../Utils/LoadingDialog";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import DropdownPrime from "../PrimeComponents/DropdownPrime";

const integrador_form = "integrador_form";

class IntegradorForm extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.status.edit && !this.props.status.edit) {
            this.props.resetForm();
        }
    }

    render() {
        const { status = {}, canEdit, data, errors, touched, t, handleSubmit, paisesList, disableInputs } = this.props;
        if (!data) return null;
        const accesos = [
            { id: 5, nombre: t("sass.tipoUsuario.5") },
            { id: 26, nombre: t("sass.tipoUsuario.26") },
            { id: 34, nombre: t("sass.tipoUsuario.34") }
        ];

        const isEdit = canEdit && status.edit;
        return (
            <div>
                <div>
                    <Form id={integrador_form} onSubmit={handleSubmit} >
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.nombre_compania}
                                    nombre1={t("sass.form.nombre_compañia")}
                                    campo1="nombre_compania"
                                    validate1={validateString50}
                                    error1={touched?.nombre_compania && errors?.nombre_compania && t(errors?.nombre_compania)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.direccion_compania}
                                    nombre1={t("sass.form.direccion")}
                                    campo1="direccion_compania"
                                    validate1={validateSomething}
                                    error1={touched?.direccion_compania && errors?.direccion_compania && t(errors?.direccion_compania)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.ciudad}
                                    nombre1={t("sass.form.ciudad")}
                                    campo1="ciudad"
                                    validate1={validateSomething}
                                    error1={touched?.ciudad && errors?.ciudad && t(errors?.ciudad)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.estado}
                                    nombre1={t("sass.form.estado")}
                                    campo1="estado"
                                    validate1={validateSomething}
                                    error1={touched?.estado && errors?.estado && t(errors?.estado)}
                                />

                                {errors?.direccion && <div className="mb-2 col-12 d-block">
                                    <div className="alert alert-warning m-0" role="alert">{`${t("validation.invalidDirCiudadEstado")} ${t("validation.length75").toLowerCase()}`}</div>
                                </div>}

                                <SelectRow
                                    edit={isEdit && !disableInputs}
                                    dataValue={data.tipo_pais_id}
                                    nombre={t("sass.form.pais")}
                                    campo="tipo_pais_id"
                                    options={paisesList}
                                    optionKey="tipo_pais_id"
                                    optionLabel="texto"
                                    placeholder={t("sass.form.pais")}
                                    validate={validateSomething}
                                    error={touched?.tipo_pais_id && errors?.tipo_pais_id && t(errors?.tipo_pais_id)}
                                />

                                <div>
                                    <span className="titulo-parametro align-middle">{t("sass.form.contacto_administrativo")}</span>
                                    <hr className="titulo-parametro-hr" />
                                </div>

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.nombre_admin}
                                    nombre1={t("sass.form.nombre")}
                                    campo1="nombre_admin"
                                    validate1={validateString50}
                                    error1={touched?.nombre_admin && errors?.nombre_admin && t(errors?.nombre_admin)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.apellido_paterno_admin}
                                    nombre1={t("sass.form.apellido_paterno")}
                                    campo1="apellido_paterno_admin"
                                    validate1={validateString50}
                                    error1={touched?.apellido_paterno_admin && errors?.apellido_paterno_admin && t(errors?.apellido_paterno_admin)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.apellido_materno_admin}
                                    nombre1={t("sass.form.apellido_materno")}
                                    campo1="apellido_materno_admin"
                                    validate1={validateOptional50}
                                    error1={touched?.apellido_materno_admin && errors?.apellido_materno_admin && t(errors?.apellido_materno_admin)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.email_admin}
                                    nombre1={t("sass.form.email")}
                                    campo1="email_admin"
                                    validate1={validateEmail50}
                                    error1={touched?.email_admin && errors?.email_admin && t(errors?.email_admin)}
                                />

                                <div>
                                    <span className="titulo-parametro align-middle">{t("sass.form.contacto_tecnico")}</span>
                                    <hr className="titulo-parametro-hr" />
                                </div>

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.nombre_tec }
                                    nombre1={t("sass.form.nombre")}
                                    campo1="nombre_tec"
                                    validate1={validateString50}
                                    error1={touched?.nombre_tec && errors?.nombre_tec && t(errors?.nombre_tec)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.apellido_paterno_tec}
                                    nombre1={t("sass.form.apellido_paterno")}
                                    campo1="apellido_paterno_tec"
                                    validate1={validateString50}
                                    error1={touched?.apellido_paterno_tec && errors?.apellido_paterno_tec && t(errors?.apellido_paterno_tec)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.apellido_materno_tec}
                                    nombre1={t("sass.form.apellido_materno")}
                                    campo1="apellido_materno_tec"
                                    validate1={validateOptional50}
                                    error1={touched?.apellido_materno_tec && errors?.apellido_materno_tec && t(errors?.apellido_materno_tec)}
                                />

                                <FormRow
                                    edit={isEdit && !disableInputs}
                                    dato1={data.email_tec}
                                    nombre1={t("sass.form.email")}
                                    campo1="email_tec"
                                    validate1={validateEmail50}
                                    error1={touched?.email_tec && errors?.email_tec && t(errors?.email_tec)}
                                />

                                <SelectRow
                                    edit={isEdit}
                                    datoValue={data.tipousuario_id}
                                    nombre={t("sass.form.acceso")}
                                    campo="tipousuario_id"
                                    options={accesos}
                                    optionKey="id"
                                    optionLabel="nombre"
                                    placeholder={t("sass.form.acceso")}
                                    validate={validateSomething}
                                    error={touched?.tipousuario_id && errors?.tipousuario_id && t(errors?.tipousuario_id)}
                                />

                                {errors?.emailNotMatch ?
                                    <div className="mb-2 col-12 d-block">
                                        <div className="alert alert-warning m-0" role="alert">{t(errors?.emailNotMatch)}</div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

class IntegradorEmailForm extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.status.edit && !this.props.status.edit) {
            this.props.resetForm();
        }
    }

    render() {
        const { status = {}, canEdit, data, errors, touched, t, handleSubmit } = this.props;
        if (!data) return null;
        const isEdit = canEdit && status.edit;
        return (
            <Form id="integrador_email_form" onSubmit={handleSubmit} >
                <div className='row'>
                    <div className='col-12 text-center'>
                        <FormRow
                            edit={isEdit}
                            dato1={data.email}
                            nombre1={t("accounts.emailContact")}
                            campo1="email"
                            validate1={validateEmail50}
                            error1={touched?.email && errors?.email && t(errors?.email)}
                        />
                    </div>
                </div>
            </Form>

        );
    }
}

const formValidate = (data, props) => {
    const errors = {};
    if (data) {
        // if no integrator, validate all fields
        if (!data.distribuidor_id){
            for (const field of Object.keys(data)) {
                if (field === "distribuidor_id") continue;
                if (field === "email_tec" || field === "email_admin") {
                    const er = validateEmail50(data[field]);
                    if (er !== undefined) errors[field] = er;
                } else if (field.includes("nombre") || field.includes("apellido_paterno")) {
                    const er = validateString50(data[field]);
                    if (er !== undefined) errors[field] = er;
                } else if (field.includes("apellido_materno")) {
                    const er = validateOptional50(data[field]);
                    if (er !== undefined) errors[field] = er;
                } else {
                    const er = validateSomething(data[field]);
                    if (er !== undefined) errors[field] = er;
                }
            }
            const direccion = (data.direccion_compania !== null ? data.direccion_compania : "") +
                (data.ciudad !== null ? `, ${data.ciudad}` : "") +
                (data.estado !== null ? `, ${data.estado}` : "");
            const er = validateString75(direccion);
            if (er !== undefined) errors.direccion = er;
            // check if email match with the one in the first form
            if (props.innerRef.current.isSubmitting && (props.verifiedEmail !== data.email_tec && props.verifiedEmail !== data.email_admin)){
                errors.emailNotMatch = "sass.form.errorEmailNoMatch";
            }
        } else {
        // if integrator, validate only access
            const er = validateSomething(data.tipousuario_id);
            if (er !== undefined) errors.tipousuario_id = er;
        }
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            nombre_compania: data.nombre_compania,
            direccion_compania: data.direccion_compania,
            ciudad: data.ciudad,
            estado: data.estado,
            tipo_pais_id: data.tipo_pais_id,
            nombre_admin: data.nombre_admin,
            apellido_paterno_admin: data.apellido_paterno_admin,
            apellido_materno_admin: data.apellido_materno_admin,
            email_admin: data.email_admin,
            nombre_tec: data.nombre_tec,
            apellido_paterno_tec: data.apellido_paterno_tec,
            apellido_materno_tec: data.apellido_materno_tec,
            email_tec: data.email_tec,
            tipousuario_id: data.tipousuario_id,
            distribuidor_id: data.distribuidor_id
        };
    },
    validate: formValidate,
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props, actions);
    }
})(withTranslation()(IntegradorForm));

const FormikFormEmail = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            email: data.email
        };
    },
    enableReinitialize: true,
    validate: async (values, props) => {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const er = validateEmail50(values.email);
                if (er !== undefined) {
                    errors.email = er;
                    return errors;
                }

                if (isSubmitting){
                    props.setForceLoading(true);
                    const endpoint = `/farms/${props.campoId}/integrador/checkIntegrador`;
                    const response = await RestAPI.post("apiAdminDropControl", endpoint, { body: { email: values.email } });
                    if (response.denied){
                        errors.email = "validation.invalidEmail";
                    }
                    props.setDataIntegrador(response.data);
                    props.setForceLoading(false);
                    return errors;
                }
            }
        } catch (error) {
            console.log("error", error);
            toast.error(props.t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            errors.unknown = error.message;
            props.setForceLoading(false);
            return errors;
        }
    },
    handleSubmit: (values, { props, ...actions }) => {
        props.checkEmail(values, props);
        if (!props.cancel) actions.setStatus({ edit: false });
    }
})(withTranslation()(IntegradorEmailForm));

// self-managed: Dialog with contact email
const FormDialog = ({ campoId, dialogState, setDialogState, paisesList, update }) => {
    const formikRef = useRef(false);
    const { t } = useTranslation();
    const [fullFormDialogState, setFullFormDialogState] = useState({ visible: false });
    const [dataIntegrador, setDataIntegrador] = useState(null);
    const [forceLoading, setForceLoading] = useState(false);

    const checkEmail = async (data) => {
        setDialogState({ visible: false });
        setFullFormDialogState({ data: dataIntegrador, verifiedEmail: data.email, visible: true, headerText: t("sass.form.integrador_autogestionado") });
    };

    return (
        <div>
            <DialogComponentWrapper formikRef={formikRef} containerId="integrador-email-form"
                t={t} dialogState={dialogState} setDialogState={setDialogState} nextButton
            >
                {forceLoading && <LoadingDialog extraClasses="fixMaxHeight" targetId="integrador_email_form" /> }
                <FormikFormEmail
                    innerRef={formikRef}
                    canEdit
                    edit={dialogState.visible}
                    data={{ email: null }}
                    checkEmail={checkEmail}
                    t={t}
                    setDataIntegrador={setDataIntegrador}
                    setForceLoading={setForceLoading}
                    campoId={campoId}
                />

            </DialogComponentWrapper>
            <FullFormDialog campoId={campoId} dialogState={fullFormDialogState}
                setDialogState={setFullFormDialogState} paisesList={paisesList} update={update}
            />
        </div>
    );

};

const FullFormDialog = ({ campoId, dialogState, setDialogState, paisesList, update }) => {
    const { t } = useTranslation();
    const promiseWrapper = useRef(null);
    const formikRef = useRef(false);
    const [info, setInfo] = useState({ isLoaded: false });
    const [forceLoading, setForceLoading] = useState(false);
    const integrador = {
        nombre_compania: dialogState.data?.distribuidor_id ? dialogState.data.nombre : null,
        direccion_compania: null,
        ciudad: null,
        estado: null,
        tipo_pais_id: dialogState.data?.tipo_pais_id ?? null,
        nombre_admin: null,
        apellido_paterno_admin: null,
        apellido_materno_admin: null,
        email_admin: dialogState.data?.email_admin ?? null,
        nombre_tec: null,
        apellido_paterno_tec: null,
        apellido_materno_tec: null,
        email_tec: dialogState.data?.email_tecnico ?? null,
        tipousuario_id: null,
        distribuidor_id: dialogState.data?.distribuidor_id ?? null
    };

    useEffect(() => {
        if (info.isLoaded && info.data) {
            update(info.data, true);
            setInfo({ isLoaded: false });
        }
    }, [info]);

    const paisesOptions = useMemo(() => {
        return paisesList?.map(pais => ({ tipo_pais_id: pais.tipo_pais_id, texto: pais.descripcion })) || [];
    }, [paisesList]);

    const connectIntegrador = async (data, args, actions) => {
        try {
            const answer = await promiseWrapper.current.getPromiseAnswer();
            data.distribuidor_id = dialogState.data?.distribuidor_id;
            let payload;
            if (answer) {
                setForceLoading(true);
                if (data.distribuidor_id){
                    payload = {
                        distribuidor_id: data.distribuidor_id,
                        tipousuario_id: data.tipousuario_id,
                        nombre_compania: data.nombre_compania,
                        email_tec: data.email_tec,
                        tipo_pais_id: data.tipo_pais_id
                    };
                } else {
                    if (data.apellido_materno_admin === "") {
                        data.apellido_materno_admin = null;
                    }
                    if (data.apellido_materno_tec === "") {
                        data.apellido_materno_tec = null;
                    }
                    data.direccion = `${data.direccion_compania ?? ""}, ${data.ciudad ?? ""}, ${data.estado ?? ""}`;
                    data.representante = `${data.nombre_admin} ${data.apellido_paterno_admin}` + (data.apellido_materno_admin !== null ? ` ${data.apellido_materno_admin}` : "");
                    payload = data;
                }

                const endpoint = `/farms/${campoId}/integrador/crearIntegrador`;
                await RestAPI.post("apiAdminDropControl", endpoint, { body: payload });
                setInfo({ isLoaded: true, data: {} });
                setDialogState({ visible: false });
                actions?.setStatus({ edit: false });
            }
        } catch (error) {
            if (error?.response?.data === "Different Domains"){
                toast.error(t("sass.form.errorInvalidDomains"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                return;
            }
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
        }
        setForceLoading(false);
    };

    return (
        <div>
            <PromiseWrapper
                ref={promiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sass.msgConfirmacionTitulo")} contentText={t("sass.msgConfirmacionBody")}
            />

            <DialogComponentWrapper formikRef={formikRef} containerId="integrador-form"
                t={t} dialogState={dialogState} setDialogState={setDialogState}
            >
                {forceLoading && <LoadingDialog extraClasses="fixMaxHeight" targetId="integrador_form" /> }
                <FormikForm
                    innerRef={formikRef}
                    canEdit edit={dialogState.visible}
                    data={integrador}
                    paisesList={paisesOptions}
                    disableInputs={Boolean(dialogState.data?.nombre)}
                    updateData={(data, args, actions) => connectIntegrador(data, args, actions)}
                    farmId={campoId}
                    verifiedEmail={dialogState?.verifiedEmail}
                />
            </DialogComponentWrapper>
        </div>
    );

};

const ConnectDialog = ({ campoId, dialogState, setDialogState, update }) => {
    const { t, i18n } = useTranslation();
    const [accesos, setAccesos] = useState(null);
    const [ref, setRef] = useState(null);
    const promiseWrapper = useRef(null);
    const [info, setInfo] = useState({ isLoaded: false });
    const [sameAccessValidation, setSameAccessValidation] = useState(false);
    const buttons = [
        {
            buttonModel: {
                cssClass: "e-primary",
                content: t("sass.conectar"),
                isPrimary: true,
            },
            click: () => {
                conectar();
            }
        },
    ];
    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );

    useEffect(() => {
        if (info.isLoaded && info.data) {
            update(info.data);
            setInfo({ isLoaded: false });
        }
    }, [info]);

    useEffect(() => {
        sameAccessValidation && setSameAccessValidation(false);
        if (dialogState && dialogState.data) {
            if (dialogState.data.tipousuario_api_permitido === null) {
                setAccesos([
                    { id: 5, nombre: t("sass.tipoUsuario.5") },
                    { id: 26, nombre: t("sass.tipoUsuario.26") },
                    { id: 34, nombre: t("sass.tipoUsuario.34") }
                ]);
            } else {
                const accesosPermitidos = dialogState.data.tipousuario_api_permitido.map((a) => {
                    return { id: a, nombre: t(`sass.tipoUsuario.${a}`) };
                });
                setAccesos(accesosPermitidos);
            }
        } else {
            setAccesos(null);
            if (ref) setRef(null);
        }
    }, [dialogState, t]);

    const conectar = async () => {
        if (ref !== null) {
            const answer = await promiseWrapper.current.getPromiseAnswer();
            if (answer) {
                const integradorId = dialogState.data && dialogState.data.distribuidor_id;
                const data = { tipousuario_id: ref };

                callSend(`/farms/${campoId}/integrador/${integradorId}/conectarIntegrador`, {}, data, t, setInfo);
                setDialogState({ visible: false });
                setRef(null);
                sameAccessValidation && setSameAccessValidation(false);
            }
        } else {
            setSameAccessValidation(true);
        }
    };
    return (
        <div id='connectDialog'>
            <PromiseWrapper
                ref={promiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sass.msgConfirmacionTitulo")} contentText={t("sass.msgConfirmacionBody")}
            />

            <Dialog
                className='dialog-prime'
                visible={dialogState.visible} closable
                draggable={false} style={{width:"1000px"}} baseZIndex={1040}
                footer={footerContent}
                onHide={() => {
                    setDialogState({ visible: false });
                    if (ref) setRef(null);
                }}
            >

                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <h5>{t("sass.integrador")}</h5>
                    </div>
                    <div className='col-12 col-md-8 text-md-left mtem-05'>
                        {dialogState.data && <h6>{dialogState.data.nombre}</h6>}
                    </div>
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <div>
                            <h5>{t("sass.descripcion")}</h5>
                        </div>
                        <div>
                            {dialogState?.data?.imagen &&
                                <img src={`https://static.dropcontrol.com/${dialogState?.data?.imagen}`}
                                    style={{ width: "100%", height: "100%" }}
                                    hidden={dialogState && dialogState.data === undefined}
                                    alt={t("sass.nologo")}
                                />}
                        </div>
                    </div>
                    <div className='col-12 col-md-8 text-md-left justify-content-end mtem-05'>
                        <h6>{dialogState && dialogState.data && dialogState.data.descripcion !== null && (dialogState.data.descripcion[i18n.language] ?? dialogState.data.descripcion["en"])}</h6>
                    </div>
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <div>
                            <h5>{t("sass.acceso")}</h5>
                        </div>
                        {sameAccessValidation &&
                            <div className="col-12 msgRawValidation" style={{ textAlign: "left" }}>
                                <span>{t("sass.form.msgValidacionNoAcceso")}</span>
                            </div>}
                    </div>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <DropdownPrime
                            filter={false}
                            value={ref}
                            onChange={(e) => {
                                setRef(e?.value);
                            }}
                            options={accesos} optionLabel="nombre"
                            optionValue="id"
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

const InfoDialog = ({ campoId, dialogState, setDialogState, update, acceso_limitado }) => {
    const { t, i18n } = useTranslation();
    const [ref, setRef] = useState(null);
    const updatePromiseWrapper = useRef(null);
    const desconectarPromiseWrapper = useRef(null);
    const [info, setInfo] = useState({ isLoaded: false });
    const [sameAccessValidation, setSameAccessValidation] = useState(false);
    const [accesos, setAccesos] = useState(null);
    const buttons = [
        {
            buttonModel: {
                cssClass: "e-danger",
                content: t("sass.modificar"),
                isPrimary: false,
                disabled: acceso_limitado
            },
            click: () => {
                updatePermiso();
            }
        },
        {
            buttonModel: {
                cssClass: "e-primary",
                content: t("sass.desconectar"),
                isPrimary: true,
            },
            click: () => {
                desconectar();
            }
        },

    ];

    useEffect(() => {
        if (info.isLoaded && info.data) {
            update(info.data);
            setInfo({ isLoaded: false });
        }
    }, [info]);

    useEffect(() => {
        if (ref && dialogState.data && dialogState.data !== null) {
            setRef(dialogState.data.tipousuario_id);
        } else {
            if (ref) setRef(null);
        }

        if (dialogState && dialogState.data) {
            if (dialogState.data.tipousuario_api_permitido === null) {
                setAccesos([
                    { id: 5, nombre: t("sass.tipoUsuario.5") },
                    { id: 26, nombre: t("sass.tipoUsuario.26") },
                    { id: 34, nombre: t("sass.tipoUsuario.34") }
                ]);
            } else {
                const accesosPermitidos = dialogState.data.tipousuario_api_permitido.map((a) => {
                    return { id: a, nombre: t(`sass.tipoUsuario.${a}`) };
                });
                setAccesos(accesosPermitidos);
            }
            if(dialogState?.data?.tipousuario_id) setRef(dialogState?.data?.tipousuario_id);
        } else {
            setAccesos(null);
        }
    }, [dialogState, t]);

    const formatoFecha = (date) => {
        const formatDate = (new Date(date)).toLocaleDateString(i18n.language);
        return formatDate;
    };

    const updatePermiso = async () => {
        if (ref !== null) {
            const answer = await updatePromiseWrapper.current.getPromiseAnswer();
            if (answer) {
                const integradorId = dialogState.data && dialogState.data.distribuidor_id;
                const usuarioApi = dialogState.data && dialogState.data.usuario_id;
                const data = { tipousuario_id: ref };

                callSend(`/farms/${campoId}/integrador/${integradorId}/updatePermiso/${usuarioApi}`, {}, data, t, setInfo);
                setDialogState({ visible: false });
                setRef(null);
                sameAccessValidation && setSameAccessValidation(false);
            }
        } else {
            setSameAccessValidation(true);
        }

    };

    const desconectar = async () => {
        const answer = await desconectarPromiseWrapper.current.getPromiseAnswer();
        if (answer) {
            const integradorId = dialogState.data && dialogState.data.distribuidor_id;
            const usuarioApi = dialogState.data && dialogState.data.usuario_id;

            callSend(`/farms/${campoId}/integrador/${integradorId}/desconectarIntegrador/${usuarioApi}`, {}, { esta_conectado: false }, t, setInfo);
            setDialogState({ visible: false });
            setRef(null);
        }

    };

    const oldPermiso = () => {
        let actividad_final = 0;
        Array.isArray(dialogState.data.actividad_id) && dialogState.data.actividad_id.forEach(act => {
            if (act > actividad_final) { actividad_final = act; }
        });
        if (actividad_final) {
            return t(`sass.tipoPermiso.${actividad_final}`);
        }
        return "";
    };

    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );
    return (
        <div id='infoDialog'>
            <PromiseWrapper
                ref={updatePromiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sass.msgUpdateConfirmacionTitulo")} contentText={t("sass.msgUpdateConfirmacionBody")}
            />
            <PromiseWrapper
                ref={desconectarPromiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sass.msgDesconectarConfirmacionTitulo")} contentText={t("sass.msgDesconectarConfirmacionBody")}
            />
            <Dialog
                className='dialog-prime'
                visible={dialogState.visible} closable draggable={false} style={{width:"1000px"}} baseZIndex={1040}
                footer={dialogState?.data?.is_old ? null : dialogState.visible && footerContent}
                onHide={() => setDialogState({ visible: false })}
            >

                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <h5>{t("sass.integrador")}</h5>
                    </div>
                    <div className='col-12 col-md-8 text-md-left mtem-05'>
                        {dialogState.data && <h6>{dialogState.data.nombre}</h6>}
                    </div>
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <h5>{t("sass.fechaCreacion")}</h5>
                    </div>
                    <div className='col-12 col-md-8 text-md-left justify-content-end mtem-05'>
                        <h6>{dialogState && dialogState.data && formatoFecha(dialogState.data.created_at)}</h6>
                    </div>
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        <div>
                            <h5>{t("sass.acceso")}</h5>
                        </div>
                        {sameAccessValidation &&
                            <div className="col-12 msgRawValidation" style={{ textAlign: "left" }}>
                                <span>{t("sass.form.msgValidacionNoAcceso")}</span>
                            </div>}
                    </div>
                    {dialogState?.data?.is_old ?
                        <div className='col-12 col-md-4 text-md-left mtem-05'>
                            <h6>{oldPermiso()}</h6>
                        </div>
                        : <div className='col-12 col-md-4 text-md-left mtem-05'>
                            <DropdownPrime
                                filter={false}
                                value={ref}
                                onChange={(e) => {
                                    setRef(e?.value);
                                }}
                                options={accesos} optionLabel="nombre"
                                optionValue="id"
                                disabled={acceso_limitado}
                            />
                        </div>}
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-12 col-md-4 text-md-left mtem-05'>
                        {dialogState?.data?.imagen &&
                            <img src={`https://static.dropcontrol.com/${dialogState?.data?.imagen}`}
                                style={{ width: "100%", height: "100%" }}
                                hidden={dialogState && dialogState.data === undefined}
                                alt={t("sass.nologo")}
                            />}
                    </div>
                    <div className='col-12 col-md-4 text-md-left mtem-05' />
                </div>

            </Dialog>

        </div>
    );
};

export { ConnectDialog, InfoDialog, FormDialog };
